import { win } from '@utils/win';

export const CURRENT_LOCALE: string = win.navigator.language;
